/* tslint:disable */
/* eslint-disable */

/**
 * 1 = StrainBridge
 * 
 * 2 = Mechanical
 * 
 * 3 = PressureGauge
 * 
 * 4 = PressureSensor
 */
export enum SensingElement {
  StrainBridge = 1,
  Mechanical = 2,
  PressureGauge = 3,
  PressureSensor = 4
}
